import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  Heading,
  DataTable,
  DataTableProps,
  HelperViewStatus,
  BaseText,
  FilterSelect,
  ContentDisplay,
  SkeletonLoader,
  HelperViewContextual
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';

import {
  getCostsCards,
  getCostsDetailsV2,
  ICostsCards,
  IMonth
} from '@/modules/cash/services/costs';
import CostSideSheet from '@/modules/cash/views/Costs/components/CostSideSheet/CostSideSheet.vue';
import { Money } from '@/modules/common/components/Money';
import MoneyCell from './components/MoneyCell/MoneyCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Costs',
  setup(__props) {

const router = useRouter();
const hasError = ref(false);
const isLoading = ref(true);
const selectedYear = ref('');
const selectedMonth = ref<IMonth>({} as IMonth);
const isSideSheetOpen = ref(false);
const availableYears = ref<string[] | null>(null);
const summary = ref<IMonth[] | null>(null);
const cards = ref<ICostsCards>({} as ICostsCards);
const isLoadingCards = ref(true);

const tableStatus = computed(() => {
  if (hasError.value) return 'error';
  if (isLoading.value) return 'loading';

  return 'default';
});

const columns: DataTableProps.Column[] = [
  {
    label: 'Mês',
    type: 'chip',
    getter: ({ month }) => ({
      text: month
    })
  },
  {
    label: 'Pendente inicial',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: 'initialPendingValue'
  },
  {
    label: 'Custos',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: 'costs'
  },
  {
    label: 'Pago',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: 'paidValue'
  },
  {
    label: 'Pendente final',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: 'finalPendingValue'
  },
  {
    label: 'Status',
    component: MoneyCell,
    align: DataTableProps.Align.Right,
    getter: ({ isClosedMonth }: IMonth) => ({
      isChip: true,
      text: isClosedMonth ? 'Fechado' : 'Aberto',
      chipColor: !isClosedMonth ? 'positive' : 'neutral'
    })
  }
];

const yearsOptions = computed(() => {
  return availableYears.value?.map(year => {
    return {
      label: String(year),
      value: String(year)
    };
  });
});

function onBack() {
  router.push({ name: 'home' });
}

function goToCostsFAQ() {
  window.open('https://warren.com.br/nosso-modelo', '_blank');
}

function goToCashbackPage() {
  if (!cards.value.cashbackCard.button?.enabled) return;
  router.push({ name: 'cashback' });
}

async function onChange(value: string) {
  selectedYear.value = value;
  await fetchCostsList();
}

function onRowClick(value: IMonth) {
  selectedMonth.value = value;
  isSideSheetOpen.value = true;
}

function handleEmptyStateButton() {
  router.back();
}

const emptyState = computed(() => {
  const hasNoYears = !availableYears.value || availableYears.value.length === 0;
  const hasNoMonths = !summary.value || summary.value.length === 0;

  return !isLoading.value && !hasError.value && hasNoMonths && hasNoYears;
});

async function fetchCostsList(setSelectedYear = false) {
  hasError.value = false;
  try {
    isLoading.value = true;

    const data = await getCostsDetailsV2(selectedYear.value);

    availableYears.value = data.availableYears;
    summary.value = data.months;

    if (
      setSelectedYear &&
      !selectedYear.value &&
      availableYears.value?.length > 0
    ) {
      selectedYear.value = String(availableYears.value[0]);
    }
  } catch (e) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchCostsCards() {
  try {
    isLoadingCards.value = true;
    const data = await getCostsCards();

    cards.value = data;
  } finally {
    isLoadingCards.value = false;
  }
}

onMounted(async () => {
  await fetchCostsList(true);
  await fetchCostsCards();
});

return { __sfc: true,router, hasError, isLoading, selectedYear, selectedMonth, isSideSheetOpen, availableYears, summary, cards, isLoadingCards, tableStatus, columns, yearsOptions, onBack, goToCostsFAQ, goToCashbackPage, onChange, onRowClick, handleEmptyStateButton, emptyState, fetchCostsList, fetchCostsCards, NavBar, Heading, DataTable, HelperViewStatus, BaseText, FilterSelect, ContentDisplay, SkeletonLoader, HelperViewContextual, BackButton, ShowMoneyToggleButton, CostSideSheet, Money }
}

})